import { joinClassNames } from "@common/lib/util"
import { TableRowProps } from "@common/table/types"
import React from "react"

const TableDetailPanel = ({ table, row, expandedRowId }: TableRowProps) => {
  const {
    getVisibleLeafColumns,
    options: {
      renderRowExpandDetails,
      themes: { tdClasses, tdSelectedBgClasses },
    },
  } = table

  const expandedDetails =
    (renderRowExpandDetails &&
      row.id === expandedRowId &&
      (row.getCanExpand() ? row.getIsExpanded() : true) &&
      renderRowExpandDetails(row.original)) ??
    null

  if (expandedDetails)
    return (
      <tr className="table-row group">
        <td
          colSpan={getVisibleLeafColumns().length}
          style={{ width: `${table.getTotalSize()}px` }}
          className={joinClassNames(tdClasses, tdSelectedBgClasses, "px-4 py-2")}
        >
          {expandedDetails}
        </td>
      </tr>
    )
  return <></>
}

export default TableDetailPanel
